var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9102_19566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73845 3.24397L10.1169 1.50292L9.7791 0.820159C9.5581 0.376363 9.01908 0.193096 8.57528 0.414095L2.86523 3.24397H3.73845Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0971 1.55273C12.0181 1.55273 11.939 1.56351 11.8599 1.58508L10.3615 1.99473L5.78516 3.24347H10.9795H13.2434L12.9631 2.21573C12.8553 1.81506 12.4924 1.55273 12.0971 1.55273Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1799 3.87305H13.9751H13.6966H13.4181H11.2925H3.48209H2.45794H1.59551H1.4356H0.900168C0.616283 3.87305 0.362942 4.00421 0.197642 4.21083C0.122179 4.30606 0.0646828 4.41566 0.0323414 4.53605C0.0125772 4.61151 0 4.69057 0 4.77142V4.87922V5.90337V14.7811C0 15.277 0.40247 15.6794 0.898372 15.6794H14.1781C14.674 15.6794 15.0765 15.277 15.0765 14.7811V12.2746H9.74554C8.90286 12.2746 8.2183 11.5901 8.2183 10.7474V9.92448V9.64598V9.36749V8.74941C8.2183 8.33616 8.38359 7.96066 8.65132 7.68575C8.88849 7.44138 9.20651 7.27608 9.56227 7.23475C9.62156 7.22759 9.68265 7.22397 9.74374 7.22397H14.329H14.6075H14.886H15.0765V4.77142C15.0783 4.27552 14.6758 3.87305 14.1799 3.87305Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7076 8.08301C15.6178 8.00036 15.5118 7.93748 15.3932 7.89615C15.3015 7.86562 15.2045 7.84766 15.1021 7.84766H15.0788H15.0608H14.7823H13.7779H9.74603C9.25011 7.84766 8.84766 8.25011 8.84766 8.74603V9.1934V9.47189V9.75039V10.7458C8.84766 11.2417 9.25011 11.6442 9.74603 11.6442H15.0788H15.1021C15.2045 11.6442 15.3016 11.6262 15.3932 11.5956C15.5118 11.5561 15.6178 11.4914 15.7076 11.4088C15.8873 11.2453 16.0005 11.0081 16.0005 10.7458V8.74603C16.0005 8.48369 15.8873 8.2465 15.7076 8.08301ZM11.6218 9.92467C11.6218 10.1726 11.4206 10.3739 11.1726 10.3739H10.8744C10.6264 10.3739 10.4252 10.1726 10.4252 9.92467V9.62641C10.4252 9.48268 10.4917 9.35509 10.5977 9.27423C10.6749 9.21494 10.7702 9.17723 10.8744 9.17723H10.9498H11.1726C11.4206 9.17723 11.6218 9.37845 11.6218 9.62641V9.92467Z",
    fill: "#2C72DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9102_19566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e137527ca9b0375bcd6d5707ffae6ae4.svg";
export { ForwardRef as ReactComponent };